// extracted by mini-css-extract-plugin
module.exports = {"ManageModel":"equipment-event_ManageModel_DgGAR"};